import { useState } from 'react';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import 'moment/locale/es';
import moment from 'moment';

// Customize the Spanish locale
moment.updateLocale('es', {
    monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
});

const CustomDatePicker = ({
    actionHandler,
    minDate,
    maxDate,
    defaultDate,
    viewType = 'full', // 'full' (year/month/day) or 'month-year' (month/year only)
}) => {
    const [datePickerOpen, setDatePickerOpen] = useState(false);

    // Configure views and format based on viewType
    const pickerConfig = {
        full: {
            views: ['year', 'month', 'day'],
            format: 'DD-MM-YYYY',
            openTo: 'day',
            placeholder: 'día/mes/año',
        },
        'month-year': {
            views: ['year', 'month'],
            format: 'MM-YYYY',
            openTo: 'year',
            placeholder: 'mes/año',
        },
    };

    const config = pickerConfig[viewType] || pickerConfig.full;

    const handleChange = (date) => {
        if (date) {
            let formattedDate;

            if (viewType === 'month-year') {
                formattedDate = moment.utc(date).format('YYYY-MM');
            } else {
                formattedDate = moment.utc(date).format('YYYY-MM-DDTHH:mm:ss');
            }

            actionHandler(formattedDate);
        }
    };

    const handleOpen = () => {
        if (!datePickerOpen) {
            setDatePickerOpen(true);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='es'>
            <DatePicker
                minDate={minDate ? minDate : null}
                maxDate={maxDate ? maxDate : null}
                onChange={handleChange}
                defaultValue={defaultDate ? defaultDate : null}
                format={config.format}
                views={config.views}
                openTo={config.openTo}
                slotProps={{
                    openPickerButton: {
                        onClick: () => handleOpen(),
                    },
                    textField: {
                        inputProps: { readOnly: true, placeholder: config.placeholder },
                        onClick: () => handleOpen(),
                    },
                }}
                sx={{
                    input: {
                        cursor: 'pointer',
                        padding: '10px',
                    },
                }}
                open={datePickerOpen}
                onClose={() => setDatePickerOpen(false)}
            />
        </LocalizationProvider>
    );
};

export default CustomDatePicker;
